import "styled-components/macro";
import {
  FaUnlock,
  FaUser,
  FaChartLine,
  FaRegMoneyBillAlt,
  FaRegCreditCard,
  FaChartPie,
  FaCheck,
} from "react-icons/fa";
import { useParams } from "react-router-dom";
// import { questionsTree, tabList } from "../utils/question";
import * as colors from "../styles/colors";
import * as fonts from "../styles/fonts";
import { useQuestion } from "../utils/question";
import { useRecommendation } from "../contexts/recommendation-context";
import * as mq from "../styles/mediaQueries";

function Progress() {
  return (
    <div
      css={`
        display: flex;
        align-items: center;
        justify-content: space-between;
        max-width: 1200px;
        margin: auto;
        margin-bottom: 3em;

        ${mq.sm} {
          display: none;
        }
      `}
    >
      <TabIcon label="Personal" id="personal">
        <FaUnlock />
      </TabIcon>
      <TabIcon label="Family" id="family">
        <FaUser />
      </TabIcon>
      <TabIcon label="Earnings" id="earnings">
        <FaChartLine />
      </TabIcon>
      <TabIcon label="Expenses" id="expenses">
        <FaRegMoneyBillAlt />
      </TabIcon>
      <TabIcon label="Debt" id="debt">
        <FaRegCreditCard />
      </TabIcon>
      <TabIcon label="Savings" id="savings">
        <FaChartPie />
      </TabIcon>
      <Icon label="All Done!" isActive={false}>
        <FaCheck />
      </Icon>
    </div>
  );
}

export { Progress };

function Icon({ children, label = "", isActive, ...props }) {
  return (
    <div
      css={`
        background-color: ${isActive ? colors.white : colors.background1};
        border: 1px solid ${isActive ? colors.darkGray : "transparent"};
        border-radius: 50%;
        display: flex;
        align-items: center;
        padding: 0.6em;
        font-size: 0.9em;
        position: relative;
        transition: all 0.3s;
        color: ${isActive ? colors.darkGray : colors.disable1};
      `}
      {...props}
    >
      {children}
      <div
        css={`
          font-family: ${fonts.three};
          font-weight: 700;
          font-size: 0.8em;
          position: absolute;
          top: calc(100% + 1.2em);
          left: 50%;
          transform: translate(-50%);
          white-space: nowrap;
        `}
      >
        {label}
      </div>
    </div>
  );
}

function TabIcon({ children, label, showProgressbar = true, id, ...props }) {
  const { tabList } = useQuestion();
  const { questions: questionsTree } = useRecommendation();
  const { tab, id: questionSequence } = useParams();
  const questionsCount = questionsTree[id].length;
  const currentQuestionIndex = questionsTree[id].findIndex(
    question => question.sequence === parseInt(questionSequence),
  );

  const isCurrentTabOver = tabList.indexOf(id) < tabList.indexOf(tab);

  const isCurrentTab = tabList.indexOf(id) === tabList.indexOf(tab);

  const isActive = isCurrentTab || isCurrentTabOver;

  const progress = isCurrentTabOver
    ? 100
    : (currentQuestionIndex / questionsCount) * 100;

  return (
    <div
      css={`
        color: ${isActive ? colors.primary : colors.disable1};
        flex: 1;
      `}
    >
      <div
        css={`
          display: flex;
          align-items: center;
        `}
        {...props}
      >
        <Icon label={label} isActive={isActive}>
          {children}
        </Icon>
        <div
          css={`
            flex: 1;
          `}
        >
          <div
            css={`
              width: 100%;
              height: 0.16em;
              background-color: ${colors.disable2};
              position: relative;

              &::before {
                transition: 0.3s ease-out;
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: ${progress}%;
                background-color: ${colors.darkGray};
              }
            `}
          />
        </div>
      </div>
    </div>
  );
}

export function ProgressMobile() {
  const { questions } = useRecommendation();
  const { id } = useParams();

  let questionsLength = 0;

  Object.keys(questions).forEach(tab => {
    questions[tab].forEach(_ => questionsLength++);
  });

  const width = (id / questionsLength) * 100;

  return (
    <div
      css={`
        width: 90%;
        height: 2px;
        position: relative;
        display: none;
        margin: auto;
        margin-top: 1em;
        background-color: ${colors.disable2};
        border-radius: 0.3rem;
        ${mq.sm} {
          display: block;
        }
      `}
    >
      <div
        css={`
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: ${width}%;
          background-color: ${colors.primary};
          border-radius: 0.3rem;
        `}
      />
    </div>
  );
}
